import Vue from 'vue';

/**
 * Subheader uses Stage template that is included in script tag
 **/

Vue.component('the-subheader', {
  template: '#js-subheader-template',
  data: function () {
    return {
      searchText: '',
    }
  },
  computed: {
    searchEnabled () {
      return this.$store.state.subheader.searchEnabled;
    },
    title () {
      return this.$store.state.subheader.title;
    },
    description () {
      return this.$store.state.subheader.description;
    },
    subtitle () {
      return this.$store.state.subheader.subtitle;
    }
  },
  watch: {
    searchText: function (value) {
      this.$store.commit('setSubheaderSearchText', this.searchText);
    }
  },
  mounted: function () {
    // Remove the original header once we're done loading
    const subheader = document.getElementById('js-subheader');
    if(subheader) {
      subheader.remove();
    }
  }
});
